import { sortedWeek } from "@TmpApp/Utils";
import { DateTime } from "luxon";
import * as React from "react";
import { OpeningsTexts, OpeningsTimes } from ".";
import { CustomerOpeningsWeek } from "@TmpApp/types";
import { useSettings } from "@Tmp/Hooks";

export type OpeningsWeekProps = {
    texts?: OpeningsTexts;
} & (
    | {
          loading?: false;
          week: CustomerOpeningsWeek;
      }
    | {
          week?: CustomerOpeningsWeek;
          loading: true;
      }
);

const currentDay = parseInt(DateTime.now().toFormat("c"));

const loadingWeek: { day: string; times?: any }[] = [
    { day: "monday" },
    { day: "tuesday" },
    { day: "wednesday" },
    { day: "thursday" },
    { day: "friday" },
    { day: "saturday" },
    { day: "sunday" },
];

const OpeningsWeek: React.FC<OpeningsWeekProps> = ({
    week: weekProp,
    loading = false,
    texts,
    ...props
}) => {
    const tmpSettings = useSettings();
    const week = loading || !weekProp ? loadingWeek : weekProp;

    const daysObject = {
        monday: "Mandag",
        tuesday: "Tirsdag",
        wednesday: "Onsdag",
        thursday: "Torsdag",
        friday: "Friday",
        saturday: "Lørdag",
        sunday: "Søndag",
    };

    tmpSettings.days?.map?.((day) => {
        daysObject[day?.day_list_type] = day?.day_list_title;
    });

    return (
        <table className="tmp-openings-table">
            <tbody>
                {week
                    .sort((a, b) => {
                        return sortedWeek.indexOf(a.day) < sortedWeek.indexOf(b.day) ? -1 : 1;
                    })
                    .map((weekDay, index) => (
                        <OpeningsTimes
                            key={index}
                            title={daysObject?.[weekDay.day] ?? weekDay.day}
                            isActive={currentDay === index + 1}
                            times={weekDay?.times}
                            loading={loading}
                            texts={texts}
                        />
                    ))}
            </tbody>
        </table>
    );
};

export default OpeningsWeek;
